exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table td{padding:5px}iframe{height:calc(100% - 4px);width:100%;border:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/stylus-loader!./src/lib/feature/feature-details/feature-details.component.styl
// module id = 938
// module chunks = 0